import styled from 'styled-components';

export const StyledVisitAndAppointmentStatusField = styled.div`
   width: 220px;
`;
StyledVisitAndAppointmentStatusField.displayName = 'StyledVisitAndAppointmentStatusField';
